<template>
  <div class="wrapper">
    <div class="banner" id="item1">
      <img src="../assets/imgs/banner.png" alt="" style="width: 100%">
    </div>
    <div class="buttons">
      <a v-scroll-to="'#item1'" >首页</a>
      <a v-scroll-to="'#item2'" >巴黎零距离</a>
      <a v-scroll-to="'#item3'" >奥运金牌榜</a>
      <a v-scroll-to="'#item4'">青岛健儿</a>
      <a v-scroll-to="'#item5'">中国军团</a>
      <a v-scroll-to="'#item6'" v-if="false">夺金时刻</a>
      <a v-scroll-to="'#item7'">动态消息</a>
      <a v-scroll-to="'#item8'">特别关注</a>
    </div>
    <div class="item1" id="item1" v-if="list1.status">
      <img src="../assets/imgs/title.png" alt="" class="title">
      <div class="list">
        <swiper :options="swiperOption4" ref="mySwiper4">
          <!-- Use v-for to iterate over images and generate the corresponding number of swiper-slide -->
          <swiper-slide v-for="(item, index) in list1" :key="index">
            <div class="item">
              <img :src="item.thumb" alt="">
              <div class="right_box">
                <p>{{item.title}}</p>
                <a :href="item.url" v-if="!isClients">查看详情</a>
                <div v-if="isClients" @click="goCentent(item.contentid,item.appid)">查看详情</div>
              </div>
            </div>
          </swiper-slide>
          <!-- Navigation buttons -->

          <div class="swiper-button-prev" slot="button-prev" @click="prevSlide"></div>
          <div class="swiper-button-next" slot="button-next" @click="nextSlide"></div>
        </swiper>
        <div class="swiper-pagination"></div>
      </div>

    </div>
    <div class="item1" style="margin-top: 0;padding: 0">
      <div class="list" style="background:none">
        <img src="../assets/imgs/gg2.png" alt="" style="width:100%;margin-top:0.22rem" @click="oPenMc" v-if="isClients">
        <img src="../assets/imgs/gg2.png" alt="" style="width:100%;margin-top:0.22rem" @click="oPenLink" v-if="!isClients">
      </div>

    </div>
    <div class="item2" id="item2" >
      <div class="title_box">
        <div class="title">巴黎零距离</div>
        <router-link :to="{ name: 'list', query: { id: '1732' }}" class="link">查看更多</router-link>
      </div>
      <div class="list">
        <ul>
          <li v-for="(item,index) in this.list2" v-if="index<4">
            <a :href="item.url" v-if="!isClients"><img :src="item.thumb" alt="">
              <div class="play-icon" v-show="item.appid==4"></div>
              <p>{{item.title}}</p>
            </a>
            <div v-if="isClients" @click="goCentent(item.contentid,item.appid)"><img :src="item.thumb" alt="">
              <div class="play-icon"  v-show="item.appid==4"></div>
              <p>{{item.title}}</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="item3" id="item3" style="background:none">
      <medal style="height:7.58rem;margin: 0.16rem auto;width: 7.02rem;"></medal>
    </div>
    <div class="item4" id="item4">
      <div class="title_box">
        <div class="title">青岛健儿</div>
        <router-link :to="{ name: 'list', query: { id: '1718' }}" class="link">查看更多</router-link>
      </div>
      <div class="list">
        <ul>
          <li v-for="(item,index) in this.list3" v-if="index<4">
            <a :href="item.url" v-if="!isClients">
              <img :src="item.thumb" alt="">
              <p>{{item.title}}</p>
              <div class="source"><span>{{item.source}}</span><span>{{item.timepoint}}</span></div>
            </a>
            <div v-if="isClients" class="a" @click="goCentent(item.contentid,item.appid)">
              <img :src="item.thumb" alt="">
              <p>{{item.title}}</p>
              <div  class="source"><span>{{item.source}}</span><span>{{item.timepoint}}</span></div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="item4" id="item5">
      <div class="title_box">
        <div class="title">中国军团</div>
        <router-link :to="{ name: 'list', query: { id: '1719' }}" class="link">查看更多</router-link>
      </div>
      <div class="list">
        <ul>
          <li v-for="(item,index) in this.list4" v-if="index<4">
            <a :href="item.url" v-if="!isClients">
              <img :src="item.thumb" alt="">
              <p>{{item.title}}</p>
              <div class="source"><span>{{item.source}}</span><span>{{item.timepoint}}</span></div>
            </a>
            <div v-if="isClients" class="a" @click="goCentent(item.contentid,item.appid)">
              <img :src="item.thumb" alt="">
              <p>{{item.title}}</p>
              <div class="source"><span>{{item.source}}</span><span>{{item.timepoint}}</span></div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="item3" id="item6" v-if="false">
      <div class="title_box">
        <div class="title">夺金时刻</div>
        <router-link :to="{ name: 'list', query: { id: '1717' }}" class="link">查看更多</router-link>
      </div>
      <div class="list">
        <div class="list">
          <swiper :options="swiperOption" ref="mySwiper">
            <!-- 使用 v-for 循环遍历 images，生成对应数量的 swiper-slide -->
            <swiper-slide v-for="(item, index) in this.list5" :key="index">

              <a :href="item.url" v-if="!isClients">
              <img :src="item.thumb" alt="">
              </a>
              <div v-if="isClients" @click="goCentent(item.contentid,item.appid)">
                <img :src="item.thumb" alt="">
              </div>
            </swiper-slide>
            <!-- 导航按钮 -->
            <div class="swiper-button-prev" slot="button-prev" @click="prevSlide"></div>
            <div class="swiper-button-next" slot="button-next" @click="nextSlide"></div>
          </swiper>
        </div>

      </div>
    </div>
    <div class="item4" id="item7">
      <div class="title_box">
        <div class="title">动态消息</div>
        <router-link :to="{ name: 'list', query: { id: '1717' }}" class="link">查看更多</router-link>
      </div>
      <div class="list">
        <ul>
          <li v-for="(item,index) in this.list6" v-if="index<4">
            <a :href="item.url" v-if="!isClients">
              <img :src="item.thumb" alt="">
              <p>{{item.title}}</p>
              <div class="source"><span>{{item.source}}</span><span>{{item.timepoint}}</span></div>
            </a>
            <div v-if="isClients" class="a" @click="goCentent(item.contentid,item.appid)">
              <img :src="item.thumb" alt="">
              <p>{{item.title}}</p>
              <div class="source"><span>{{item.source}}</span><span>{{item.timepoint}}</span></div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="item2" id="item8" >
      <div class="title_box">
        <div class="title">特别关注</div>
        <router-link :to="{ name: 'list', query: { id: '1720' }}" class="link">查看更多</router-link>
      </div>
      <div class="list">
        <ul>
          <li v-for="(item,index) in this.list7" v-if="index<4">
            <a :href="item.url" v-if="!isClients"><img :src="item.thumb" alt="">
              <div class="play-icon" v-show="item.appid==4"></div>
              <p>{{item.title}}</p>
            </a>
            <div v-if="isClients" @click="goCentent(item.contentid,item.appid)"><img :src="item.thumb" alt="">
              <div class="play-icon"  v-show="item.appid==4"></div>
              <p>{{item.title}}</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="footer">
      <img src="../assets/imgs/bottom.png" alt="">
    </div>
    <div class="fixed-bottom-right" >
      <img src="../assets/imgs/gg3.png" alt=""  @click="oPenMc1" v-if="isClients">
      <img src="../assets/imgs/gg3.png" alt=""  @click="oPenLink1" v-if="!isClients">
    </div>
  </div>
</template>

<script>
import medal from '../components/medal'; // 引入子组件
import { swiper, swiperSlide } from "vue-awesome-swiper/dist/vue-awesome-swiper.js";
import 'swiper/dist/css/swiper.css';
import { openapi_get_url } from "../assets/js/Request";
import axios from "axios";
import { Loading } from "element-ui";
import $ from "jquery";
let loading;
const startLoading = () => {
  // 使用Element loading-start 方法
  loading = Loading.service({
    lock: true,
    text: "加载中……",
    background: "rgba(255, 255, 255, 0.7)",
  });
};
startLoading();


export default {
  components: {
    swiper,
    swiperSlide,
    medal
  },
  name: "index",
  data() {
    return {
      list1:[],
      list2:[],
      list3:[],
      list4:[],
      list5:[],
      list6:[],
      list7:[],
      isClients:false,
      swiper: null,
      // swiperOption: {
      //   loop: false,
      //   autoplay: {
      //     delay: 3000,
      //     stopOnLastSlide: false,
      //     disableOnInteraction: false
      //   },
      //   navigation: {
      //     nextEl: '.swiper-button-next',
      //     prevEl: '.swiper-button-prev',
      //   }
      // },
      // swiperOption4: {
      //   loop: false,
      //   autoplay: {
      //     delay: 9000,
      //     stopOnLastSlide: false,
      //     disableOnInteraction: false
      //   },
      //   pagination: {
      //     el: '.swiper-pagination',
      //     clickable: true
      //   },
      //   navigation: {
      //     nextEl: '.swiper-button-next',
      //     prevEl: '.swiper-button-prev',
      //     hideOnClick: true,
      //   }
      // },
      // swiperOption2: {
      //   loop: false,
      //   slidesPerView: 3, // 一行显示的项数
      //   spaceBetween: 10, // 项之间的间隔
      //   autoplay: {
      //     delay: 3000,
      //     stopOnLastSlide: false,
      //     disableOnInteraction: false
      //   },
      // }
    };
  },
  watch: {

  },
  created() {

    //晓婷逛巴黎 ---
    // this.getData('',1)
    //巴黎零距离----
    this.getData(1732,2)
    //青岛健儿
    this.getData(1718,3)
    //中国军团
    this.getData(1719,4)
    //夺金时刻----
    // this.getData('',5)
    //动态消息
    this.getData(1717,6)
    //特别关注
    this.getData(1720,7)
  },
  mounted() {
    this.isClients = mc.isClient();
    loading.close();
    // this.initSwiper();
  },
  methods: {
    oPenMc(){
      mc.openContentView({
        "contentid":49,
        "appid":10200
      });
    },
    oPenLink(){
      window.location.href='https://m.guanhai.com.cn/topic/shareTopic.html?topic_id=49';
    },
    oPenMc1(){
      mc.openContentView({
        "url":"https://app.guanhai.com.cn/dui/index/getNoLoginUrl?dbredirect=https%3A%2F%2F73660.activity-42.m.duiba.com.cn%2Fsign%2Fcomponent%2Fpage%3FsignOperatingId%3D269124654233477",
        "appid":3
      });
    },
    oPenLink1(){
      window.location.href='https://gh.guanhai.com.cn';
    },
    goCentent(contentid,appid){
      mc.openContentView({
        "contentid":contentid,
        "appid":appid,
        "siteid":"10001"
      })
    },
    // prevSlide() {
    //   this.$refs.mySwiper.swiper.slidePrev();
    // },
    // nextSlide() {
    //   this.$refs.mySwiper.swiper.slideNext();
    // },
    getData(tagid,List) {
      axios(openapi_get_url('special/mobileTag', {
        'content_id': 327839,
        'tagid':tagid,
        'page':1,
        'pagesize':50
      })).then((response) => {
        if(List==1){
          this.list1 = response.data.data.list
        }else if(List==2){
          this.list2 = response.data.data.list
        }else if(List==3){
          this.list3 = response.data.data.list
        }else if(List==4){
          this.list4 = response.data.data.list
        }else if(List==5){
          this.list5 = response.data.data.list
        }else if(List==6){
          this.list6 = response.data.data.list
        }else{
          this.list7 = response.data.data.list
        }

      });
    },
    // initSwiper() {
    //   // 使用 $refs 来访问组件引用并初始化 Swiper
    //   this.$refs.mySwiper.swiper.init();
    //   this.$refs.mySwiper4.swiper.init();
    // }
  }

};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/index.vue